import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormArray,
  FormBuilder,
  Validators,
  NgForm
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";

import { AppConfig } from "../../../core/config/app.config";
import { Utills } from "../../../core/utility/utills";
import { TmpStorage } from "../../../core/utility/temp.storage";
import { WebStorage } from "../../../core/utility/web.storage";
import { AuthService } from "../../../core/services/auth.service";
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProgressSpinnerModule } from "primeng/primeng";
import {
  NavigationStart,
  NavigationCancel,
  NavigationEnd
} from "@angular/router";

import { requiredTrim } from "../../../core/validators/validators";

@Component({
  selector: "app-login",
  preserveWhitespaces: false,
  templateUrl: "./view/login.component.html"
})
export class LoginComponent {
  commingsoon: boolean;
  public userlogin: FormGroup;
  private redirectUrl: any;
  public httpCall: any = false;
  loading: any;

  err: any;

  constructor(
    private toaster: ToastrService,
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private utills: Utills,
    private tmpStorage: TmpStorage,
    private config: AppConfig,
    private storage: WebStorage,
    private router: Router
  ) {
    this.loading = true;
    this.redirectUrl = this.utills.notEmpty(this.tmpStorage.get("redirectUrl"))
      ? this.tmpStorage.get("redirectUrl")
      : "user/dashboard";
    this.tmpStorage.remove("redirectUrl");
    this.userlogin = formBuilder.group({
      email: ["", [requiredTrim, Validators.required]],
      password: ["", [requiredTrim, Validators.required]],
      rememberme: []
    });
  }

  login() {
    if (this.userlogin.valid) {
      this.userlogin.value.email = this.userlogin.value.email.trim();
      this.auth.login(this.userlogin.value).subscribe((res: any) => {
        this.httpCall = false;
        if (res.success) {
          if (res.data.user.role == this.config.role_type.admin) {
            this.router.navigate(["user"]);
          } else if (res.data.user.role == this.config.role_type.employee) {
            this.router.navigate(["user"]);
          } else {
            this.toaster.info(
              "Currently working on this page :" + res.data.user.role
            );
          }
        } else {
          this.httpCall = false;
          //console.log(res);
          this.toaster.error(res.message);
        }
      });
    }
  }
  support() {
    this.commingsoon = true;
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }
}
